<section class="agpr-agentSummary">
    <agpr-panel
        *ngIf="attributes && showDetails"
        header="Social.agentWidget.socialTopicDetails"
    >
        <agpr-attribute-list
            [attributes]="attributes"
        ></agpr-attribute-list>
    </agpr-panel>

    <agpr-panel
        header="Social.agentWidget.socialTopicQuery"
        *ngIf="_agent"
    >
        <div class="agpr-agentSummary-searchQuery">
            <dl class="agpr-definitionList ui-g">
                <dt class="agpr-definitionList-definitionTitle ui-g-12">
                    {{  'Social.agentWidget.availableNetworks' | localize }}
                </dt>
                <dd class="agpr-definitionList-definition">
                    <ng-container *ngFor="let mediaType of availableNetworks; let last = last;">
                        {{ 'Social.network.' + mediaType | localize }}
                        <span *ngIf="!last" class="agpr-agentSummary-operator">
                            {{ 'Monitoring.searchCriteria.or' | localize }}
                        </span>
                    </ng-container>
                </dd>

                <dt class="agpr-definitionList-definitionTitle ui-g-12">
                    {{ 'Keywords' | localize }}
                </dt>
                <dd class="agpr-definitionList-definition">
                    <agpr-keyword-group-summary
                        [keywordGroup]="_agent.keywords"
                    ></agpr-keyword-group-summary>
                </dd>

                <dt class="agpr-definitionList-definitionTitle ui-g-12">
                    {{ 'Handles' | localize }}
                </dt>
                <dd class="agpr-definitionList-definition">
                    <div
                        class="agpr-agentSummary-handleList"
                        *ngFor="let mediaTypeRequest of _agent.mediaTypeRequests; let last = last;"
                        [ngClass]="{'agpr-agentSummary-handleList--bottomMargin': !last}"
                    >
                        <ng-container *ngIf="mediaTypeRequest.handles?.length > 0">
                            <span class="agpr-definitionList-definitionTitle ui-g-12 agpr-agentSummary-handleList-name">
                                <ng-container *ngIf="mediaTypeRequest.mediaType !== mediaSubscriptionMediaTypes.reddit">
                                    {{ 'Social.network.' + mediaTypeRequest.mediaType | localize }}
                                </ng-container>
                                <ng-container *ngIf="mediaTypeRequest.mediaType === mediaSubscriptionMediaTypes.reddit">
                                    {{ 'Social.network.query.' + mediaTypeRequest.mediaType | localize }}
                                </ng-container>
                            </span>
                            <div>
                                <span *ngFor="let handle of mediaTypeRequest.handles; let lastHandle = last;">
                                    <ng-container *ngIf="!lastHandle"> {{ handle + ', ' }} </ng-container>
                                    <ng-container *ngIf="lastHandle"> {{ handle}} </ng-container>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </dd>
            </dl>
        </div>
    </agpr-panel>
    <ng-container *ngFor="let network of _networks">
        <!-- Twitter -->
        <agpr-panel
            *ngIf="network === networkTypes.twitter"
            class="agpr-agentSummary-twitterAdditionalSettings"
            header="Social.agentWidget.additionalSettings.twitter"
        >
            <div *ngIf="twitterAdditionalSettings" class="agpr-agentSummary-twitterAdditionalSettings">
                <dl class="agpr-definitionList ui-g">
                    <dt class="agpr-definitionList-definitionTitle ui-g-12">
                        {{  'Social.agentSearchSettings.twitter.sampleRate' | localize }}
                    </dt>
                    <dd class="agpr-definitionList-definition">
                        {{ twitterAdditionalSettings.samplePercentage }}
                    </dd>

                    <dt
                        *ngIf="twitterAdditionalSettings.languageFilter.include.length > 0 || twitterAdditionalSettings.languageFilter.exclude.length > 0"
                        class="agpr-definitionList-definitionTitle ui-g-12"
                    >
                        {{ 'Social.agentSearchSettings.twitter.language' | localize }}
                    </dt>
                    <dd class="agpr-definitionList-definition">
                        <div *ngIf="twitterAdditionalSettings.languageFilter.include.length > 0">
                            (
                            <ng-container *ngFor="let orLanguage of twitterAdditionalSettings.languageFilter.include; let last = last;">
                              <span class="agpr-keywordGroupSummary-keyword">
                                {{ orLanguage | localize }}
                              </span>
                              <span *ngIf="!last" class="agpr-keywordGroupSummary-operator">
                                  {{ 'KeywordGroupSummary.or' | localize }}
                              </span>
                            </ng-container>
                            )
                          </div>
                          <div *ngIf="twitterAdditionalSettings.languageFilter.exclude.length > 0">
                            <span class="agpr-keywordGroupSummary-operator">
                                {{ 'KeywordGroupSummary.not' | localize }}
                            </span>
                            (
                            <ng-container *ngFor="let notLanguage of twitterAdditionalSettings.languageFilter.exclude; let last = last;">
                              <span class="agpr-keywordGroupSummary-keyword">
                                {{ notLanguage | localize }}
                              </span>
                              <span *ngIf="!last" class="agpr-keywordGroupSummary-operator">
                                  {{ 'KeywordGroupSummary.or' | localize }}
                              </span>
                            </ng-container>
                            )
                          </div>
                    </dd>

                    <ng-container *ngIf="twitterAdditionalSettings.verifiedAuthor !== null">
                        <dt  class="agpr-definitionList-definitionTitle ui-g-12">
                            {{ 'Social.agentSearchSettings.twitter.verified' | localize }}
                        </dt>
                        <dd class="agpr-definitionList-definition">
                                {{ twitterAdditionalSettings.verifiedAuthor ?
                                    ('Social.agentSearchSettings.twitter.verified.include' | localize)  :
                                    ('Social.agentSearchSettings.twitter.verified.exclude' | localize)
                                }}

                        </dd>
                    </ng-container>


                    <dt *ngIf="twitterAdditionalSettings.countryCodes.length > 0" class="agpr-definitionList-definitionTitle ui-g-12">
                        {{ 'Social.agentSearchSettings.twitter.country'| localize }}
                    </dt>
                    <dd class="agpr-definitionList-definition">
                        <div>
                            <span *ngFor="let country of twitterAdditionalSettings.countryCodes; let lastCountry = last;">
                                <ng-container *ngIf="!lastCountry"> {{ country + ', ' }} </ng-container>
                                <ng-container *ngIf="lastCountry"> {{ country}} </ng-container>
                            </span>
                        </div>
                    </dd>

                    <ng-container *ngFor="let geoCircle of twitterAdditionalSettings.geoCircles; let i = index">
                        <dt class="agpr-definitionList-definitionTitle ui-g-12">
                            {{ ('Social.agentSearchSettings.twitter.geoPicker.label' | localize) + ' ' + (i + 1) }}
                        </dt>
                        <dd
                            class="agpr-definitionList-definition agpr-agentSummary-geoCoordinates"
                            [ngClass]="{'agpr-agentSummary-handleList--bottomMargin': !last}"
                        >
                            <span class="agpr-definitionList-definitionTitle ui-g-12 agpr-agentSummary-geoCoordinates-title">
                                {{ 'Social.agentWidget.additionalSettings.geoCoordinates' | localize }}
                            </span>
                            <span class="agpr-agentSummary-geoCoordinates-value" >
                                {{ geoCircle.latitude + ', ' + geoCircle.longitude }}
                            </span>
                            <span class="agpr-definitionList-definitionTitle ui-g-12 agpr-agentSummary-geoCoordinates-title">
                                {{ 'Social.agentSearchSettings.twitter.geoPicker.radius' | localize }}
                            </span>
                            <span class="agpr-agentSummary-geoCoordinates-value" >
                                {{ geoCircle.radius + (geoCircle.radiusUnit === geoRadiusUnit.km ? ' km' : ' mi') }}
                            </span>
                        </dd>
                    </ng-container>
                </dl>
            </div>
        </agpr-panel>
    </ng-container>
</section>
